export enum AMOUNT_TYPE {
  LIMITED = 'Limited',
  UNLIMITED = 'Unlimited',
}
